import { useParams, Navigate } from 'react-router-dom';
import Events from './Events';
import regionsData from '@/data/regions.json';

const VALID_SLUGS = new Set(Object.keys(regionsData));

const EventsRegion = () => {
  const { slug } = useParams();

  if (!slug || !VALID_SLUGS.has(slug)) return <Navigate to="/events" replace />;

  // Keyed on the route param so navigating between regions remounts Events
  // and reseeds the region filter from the new default.
  return <Events key={slug} defaultRegion={slug} />;
};

export default EventsRegion;
